import sty from './h.module.scss';
import { useNavigate } from 'react-router-dom';

export default function Header2({ href, title, ltitle }) {
  const navigate = useNavigate();
  const pi=()=>{
  	window.location.href="/";
  }
  //navigate(-1)
  return (
    <div className={sty.he}>
    	<div className={sty.lef}>
	      <div className={sty.back} onClick={() => pi()}></div> 
	      <div className={sty.txt} onClick={() => pi()}>{ltitle}</div>
        </div>
      <a href={href}>{title}</a>
    </div>
  );
}
